import { useTable, Column } from "react-table";
import clsx from "clsx";
import ClientProfileModulesTableHeader from "./ClientProfileModulesTableHeader";
import ClientProfileModulesTableBody from "./ClientProfileModulesTableBody";

interface ClientProfileModulesTableProps<T extends { id: number }> {
  modules: T[]; // 👈 lista resumida (id, name, etc.)
  columns: Column<T>[];
  getExpandedComponent?: (row: T) => React.ReactNode;
  maxWidth?: string;
  enableRowClick?: boolean;
}

const ClientProfileModulesTable = <T extends { id: number }>({
  modules,
  columns,
  getExpandedComponent,
  maxWidth = "max-w-none",
  enableRowClick = false,
}: ClientProfileModulesTableProps<T>) => {
  const table = useTable<T>({
    columns,
    data: modules,
  });

  return (
    <div
      className={clsx(
        "w-full rounded-lg border border-stroke bg-white shadow-default dark:border-strokedark dark:bg-boxdark",
        maxWidth
      )}
    >
      <section className="data-table-common">
        <div className="w-full overflow-x-auto">
          <table
            {...table.getTableProps()}
            className="datatable-table w-full min-w-[700px] table-fixed border-collapse break-words"
          >
            {/* 🔹 Encabezados */}
            <ClientProfileModulesTableHeader table={table} />

            {/* 🔹 Cuerpo con filas + expansión */}
            <ClientProfileModulesTableBody<T>
              table={table}
              enableRowClick={enableRowClick}
              getExpandedComponent={(row) => getExpandedComponent?.(row)}
              noDataMessage="Este perfil no tiene módulos habilitados."
            />
          </table>
        </div>
      </section>
    </div>
  );
};

export default ClientProfileModulesTable;
